import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider, Spin } from 'antd';
import jaJP from 'antd/locale/ja_JP';
import { AppRouter } from './Router';
import { useAuthStore } from '@/features/auth/stores/authStore';

export const App: React.FC = () => {
  const isInitialized = useAuthStore((state) => state.isInitialized);
  const checkAuth = useAuthStore((state) => state.checkAuth);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  // 認証チェック完了まで全体をローディング表示
  if (!isInitialized) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spin size="large" tip="初期化中..." />
      </div>
    );
  }

  return (
    <ConfigProvider locale={jaJP}>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </ConfigProvider>
  );
};
